<template>
  <b-modal :visible="isOpen"
           @shown="checkFieldsState = true"
           lazy
           centered
           ok-variant="ls order-button-text"
           :ok-disabled="disableOk"
           :ok-title-html="$t('Redeem')"
           :cancel-title="$t('Cancel')"
           :title="$t('Redeem reward')"
           @ok="orderReward"
           @hidden="clearModal"
           @show="onShow"
           size="lg">
    <b-alert :show="warningMessage.length" fade variant="warning">
      <i class="fa fa-lg fa-exclamation-circle"></i>
      {{ warningMessage }}
    </b-alert>

    <div v-if="stateOrder" class="form-group d-flex flex-row">
      <b-img v-if="stateOrder.picture" :src="stateOrder.picture" height="100" class="m--padding-right-15"></b-img>
      <div>
        <h4>{{ stateOrder.name }}</h4>
        <p v-if="points>0">
          {{pointsName}} {{$t('you can use:')}}
          <span class="m-badge m-badge--wide m-badge--ls">{{ points }} {{pointsSymbol}}</span>
        </p>
      </div>
    </div>
    <div v-if="stateOrder" class="form-group row">
      <label for="quantity" class="col-5 col-md-3 col-form-label">{{$t('Quantity *')}}</label>
      <div class="col-7 col-md-9">
        <input class="form-control" id="quantity"
               :class="[state.order.quantity === false && 'is-invalid', state.order.quantity === true && 'is-valid']"
               type="number"
               min="1"
               :max="stateOrder.order_limit"
               required
               v-model="order.quantity"/>
      </div>
    </div>
    <div v-if="showDeliveryMethodSelect" class="form-group row">
      <label for="name" class="col-5 col-md-3 col-form-label">{{$t('Collection method *')}}</label>
      <div class="col-7 col-md-9">
        <b-form-select id="name"
                       type="text"
                       required
                       :state="state.order.delivery"
                       v-model="order.delivery"
                       :options="deliveryMethods"></b-form-select>
      </div>
    </div>
    <div v-if="showShipmentForm">
      <div class="form-group row">
        <label for="name" class="col-5 col-md-3 col-form-label">{{$t('Name *')}}</label>
        <div class="col-7 col-md-9">
          <b-form-input id="name"
                        type="text"
                        maxlength="30"
                        required
                        :state="state.order.name"
                        v-model="order.name"></b-form-input>
        </div>
      </div>
      <div class="form-group row">
        <label for="surname" class="col-5 col-md-3 col-form-label">{{$t('Surname *')}}</label>
        <div class="col-7 col-md-9">
          <b-form-input id="surname"
                        type="text"
                        maxlength="30"
                        required
                        :state="state.order.surname"
                        v-model="order.surname"></b-form-input>
        </div>
      </div>
      <div class="form-group row">
        <label for="address" class="col-5 col-md-3 col-form-label">{{$t('Address *')}}</label>
        <div class="col-7 col-md-9">
          <b-form-input id="address"
                        type="text"
                        maxlength="50"
                        required
                        :state="state.order.address"
                        v-model="order.address"></b-form-input>
        </div>
      </div>
      <div class="form-group row">
        <label for="city" class="col-5 col-md-3 col-form-label">{{$t('City *')}}</label>
        <div class="col-7 col-md-9">
          <b-form-input id="city"
                        type="text"
                        maxlength="30"
                        required
                        :state="state.order.city"
                        v-model="order.city"></b-form-input>
        </div>
      </div>
      <div class="form-group row">
        <label for="postcode" class="col-5 col-md-3 col-form-label">{{$t('Postal Code *')}}</label>
        <div class="col-7 col-md-9">
          <b-form-input id="postcode"
                        type="text"
                        maxlength="6"
                        inputmode="numeric"
                        :placeholder="$t('np: 00-000')"
                        :formatter="formatPostcode"
                        required
                        :state="state.order.postcode"
                        v-model="order.postcode"></b-form-input>
        </div>
      </div>
      <div class="form-group row">
        <label for="phone" class="col-5 col-md-3 col-form-label">{{$t('Phone Number *')}}</label>
        <div class="col-7 col-md-9">
          <div class="row">
            <div class="col-3 pr-1">
              <b-form-select v-model="order.phone_calling_code"
                             :options="callingCodeOptions"
                             class="form-control m-input"
              ></b-form-select>
            </div>
            <div class="col-9 pl-1">
              <b-form-input id="phone"
                            maxlength="12"
                            type="tel"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            autocomplete="tel-national"
                            :placeholder="$t('Enter the phone number without the country code')"
                            v-model="order.phone_local"
                            @paste.native="handlePhonePaste"
                            @keydown.native="onlyNumber"
                            @input="order.phone_local = order.phone_local.replace(/\D/g, '')"
              ></b-form-input>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="form-group row">
      <label for="details" class="col-5 col-md-3 col-form-label">{{$t('Comments')}}</label>
      <div class="col-7 col-md-9">
        <b-form-textarea id="details"
                         v-model="order.details"></b-form-textarea>
      </div>
    </div>
    <div class="mt-4">
    {{$t('* - Required field')}}
    </div>
  </b-modal>
</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import PushIfExists from "@/mixins/pushIfExists";
  import { formatPostcode, isValidNamePart, isValidPostcode } from '@/utils/standardFieldValidation';

  export default {
    name: "OrderRewardModal",
    mixins: [PushIfExists],
    data() {
      return {
        checkFieldsState: false,
        warningMessage: "",
        disableOk: false,
        deliveryMethods: [],
        order: {
          delivery: "",
          name: "",
          surname: "",
          address: "",
          city: "",
          postcode: "",
          phone: "",
          phone_calling_code: null,
          phone_local: "",
          details: "",
          quantity: "1",
        },
        state: {
          order: {
            delivery: null,
            name: null,
            surname: null,
            address: null,
            city: null,
            postcode: null,
            phone: null,
            quantity: null,
          },
        }
      }
    },
    methods: {
      ...mapActions([
        'clearOrder',
        'clearVariantsOrderModalId',
        'clearVariantsOrder',
        'fetchUser'
      ]),
      setFieldState(field) {
        if (!this.checkFieldsState) {
          return;
        }

        this.state.order[field] = !!(this.order[field] && this.order[field].length);
      },
      checkPhonePattern() {
        //wspólna reguła (LSD-525): część lokalna 6-12 cyfr, całość ≤15 cyfr bez znaku +
        const localDigits = (this.order.phone_local || '').replace(/\D/g, '');
        const totalDigits = (this.order.phone || '').replace(/\D/g, '');
        return /^[0-9]{6,12}$/.test(localDigits) && totalDigits.length <= 15;
      },
      onShow() {
        this.disableOk = false;
        this.warningMessage = "";
        this.checkFieldsState = false;
        this.setupDeliveries();
        this.cloneUserFromState();
      },
      onlyNumber(event) {
        // Pozwalaj na klawisze sterujące
        const isControlKey = [
          'Backspace', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight',
          'ArrowUp', 'ArrowDown', 'Delete', 'Home', 'End'
        ].includes(event.key);

        // Pozwalaj na kombinacje z Ctrl/Cmd (np. Ctrl+C, Ctrl+V, Ctrl+A)
        const isCombinedKey = event.ctrlKey || event.metaKey;

        // Pozwalaj tylko na cyfry
        const isDigit = /^\d$/.test(event.key);

        if (!isDigit && !isControlKey && !isCombinedKey) {
          event.preventDefault();
          return false;
        }
        return true;
      },
      setupDeliveries() {
        this.deliveryMethods = [
          {
            value: '',
            text: this.$t('Choose')
          }
        ];

        if (this.delivery.shipment) {
          this.deliveryMethods.push({
            value: 'shipment',
            text: this.$t('Shipmnent on address'),
          });
        }

        if (this.delivery.pickup && this.delivery.pickupShops.length) {
          this.delivery.pickupShops.forEach((shop) => {
            this.deliveryMethods.push({
              value: this.$t('Pickup-') + shop.id,
              text: this.$t('Pickup in') + ' ' + shop.name,
            });
          })
        }

        if (!this.showDeliveryMethodSelect) {
          this.order.delivery = 'shipment'; //default shipment
        }
      },
      cloneUserFromState() {
        this.order.name = this.stateUser.name || '';
        this.order.surname = this.stateUser.surname || '';
        this.order.address = this.stateUser.address || '';
        this.order.city = this.stateUser.city || '';
        this.order.postcode = this.stateUser.postcode || '';
        this.order.phone = this.stateUser.phone || '';
        this.parsePhone();
      },
      parsePhone() {
        const phone = this.order.phone || '';
        const defaultCallingCode = this.defaultCallingCode;

        if (phone.startsWith('+') || phone.startsWith('00')) {
          let normalizedPhone = phone;
          if (phone.startsWith('00')) {
            normalizedPhone = '+' + phone.substring(2);
          }

          const codes = Object.keys(this.callingCodes).sort((a, b) => b.length - a.length);
          let found = false;
          for (const code of codes) {
            if (normalizedPhone.startsWith(code)) {
              this.order.phone_calling_code = code;
              this.order.phone_local = normalizedPhone.substring(code.length);
              found = true;
              break;
            }
          }
          if (!found) {
            this.order.phone_calling_code = defaultCallingCode;
            this.order.phone_local = phone;
          }
        } else {
          this.order.phone_calling_code = defaultCallingCode;
          this.order.phone_local = phone;
        }
      },
      handlePhonePaste(e) {
        const pastedData = e.clipboardData.getData('text');
        const cleanedData = pastedData.replace(/[\s()-]/g, '');

        if (cleanedData.startsWith('+') || cleanedData.startsWith('00')) {
          let searchData = cleanedData.startsWith('00') ? '+' + cleanedData.substring(2) : cleanedData;

          const options = Object.keys(this.callingCodes).sort((a, b) => b.length - a.length);
          let prefix = '';
          let local = '';

          for (const code of options) {
            if (searchData.indexOf(code) === 0) {
              prefix = code;
              local = searchData.substring(code.length);
              break;
            }
          }

          if (prefix) {
            this.order.phone_calling_code = prefix;
            setTimeout(() => {
              this.order.phone_local = local;
            }, 0);
            e.preventDefault();
          }
        }
      },
      clearForm() {
        this.order.delivery = "";
        this.order.name = "";
        this.order.surname = "";
        this.order.address = "";
        this.order.city = "";
        this.order.postcode = "";
        this.order.phone = "";
        this.order.phone_local = "";
        this.order.phone_calling_code = this.defaultCallingCode || null;
        this.order.details = "";
        this.order.quantity = "1";

        this.clearFormState();
      },
      clearFormState() {
        this.state.order.delivery = null;
        this.state.order.name = null;
        this.state.order.surname = null;
        this.state.order.address = null;
        this.state.order.city = null;
        this.state.order.postcode = null;
        this.state.order.phone = null;
        this.state.order.quantity = null;
      },
      clearModal() {
        this.clearOrder();
        this.clearVariantsOrderModalId();
        this.clearVariantsOrder();
        this.clearForm();
        this.checkFieldsState = false;
        this.warningMessage = "";
      },
      formatPostcode(value) {
        //wspólna reguła (LSD-526): tylko cyfry, myślnik wstawiany automatycznie po 2 cyfrach
        return formatPostcode(value);
      },
      validateForm() {
        const quantity = Number.parseInt(this.order.quantity, 10);
        this.state.order.quantity = Boolean(
          this.stateOrder
          && Number.isInteger(quantity)
          && quantity >= 1
          && quantity <= this.stateOrder.order_limit
        );
        this.state.order.delivery = !this.showDeliveryMethodSelect || Boolean(this.order.delivery);

        if (this.order.delivery.startsWith('pickup')) {
          this.state.order.name = null;
          this.state.order.surname = null;
          this.state.order.address = null;
          this.state.order.city = null;
          this.state.order.postcode = null;
          this.state.order.phone = null;
          return;
        }

        this.state.order.name = Boolean(this.order.name);
        this.state.order.surname = Boolean(this.order.surname);
        this.state.order.address = Boolean(this.order.address);
        this.state.order.city = Boolean(this.order.city);
        this.state.order.postcode = Boolean(this.order.postcode);
        this.state.order.phone = Boolean(this.order.phone);
      },
      orderReward(e) {
        e.preventDefault();
        this.warningMessage = "";

        if (this.order.phone_local) {
          this.order.phone = (this.order.phone_calling_code || '') + this.order.phone_local.replace(/\D/g, '');
        } else {
          this.order.phone = '';
        }

        this.validateForm();

        //walidacja synchroniczna przy submicie (por. ProfilePage.vue)
        if (this.showShipmentForm && this.order.phone && !this.checkPhonePattern()) {
          this.state.order.phone = false;
          this.warningMessage = this.$t('Enter a valid phone number.');
          return;
        }

        //wspólne reguły (LSD-526): min 2 znaki dla imienia/nazwiska, kod pocztowy 00-000
        if (this.showShipmentForm) {
          if (!isValidNamePart(this.order.name)) {
            this.state.order.name = false;
            this.warningMessage = this.$t('Name contains minimun 2 chars');
            return;
          }

          if (!isValidNamePart(this.order.surname)) {
            this.state.order.surname = false;
            this.warningMessage = this.$t('Surname contains minimun 2 chars');
            return;
          }

          if (!isValidPostcode(this.order.postcode)) {
            this.state.order.postcode = false;
            this.warningMessage = this.$t('Post code format 00-000');
            return;
          }
        }

        this.isFormValid
          ?
            (this.disableOk = true) && (function(self){
              const delivery = {
                name: self.order.name,
                surname: self.order.surname,
                address: self.order.address,
                city: self.order.city,
                postcode: self.order.postcode,
                details: self.order.details,
                phone: self.order.phone || '',
              };
              return self.$http.post('/rewards', {
                rewardId: self.stateOrder.id,
                quantity: self.order.quantity,
                deliveryType: self.order.delivery,
                delivery: delivery,
              })
            })(this)
            .then((r) => {
              this.disableOk = false;
              if (r.data.success) {
                this.fetchUser();
                this.clearModal();
                this.pushIfExists({name: 'ReceivedRewardsPage'});
                this.$notify(r.data.message, 'info');
              } else {
                this.warningMessage = r.data.message;
              }
            })
            .catch(() => {
              this.disableOk = false;
              this.warningMessage = this.$t('Error occurred, try again');
            })
          : this.warningMessage = this.order.quantity > 0
          ? this.$t('Fill all required fields')
          : this.$t('Number of rewards greater than 0')
      }
    },
    computed: {
      ...mapState({
        isOpen: state => state.rewards.order !== null,
        stateOrder: state => state.rewards.order,
        stateUser: state => state.auth.user,
        delivery: state => state.settings.rewardsOrdersDelivery,
        callingCodes: state => state.settings.callingCodes,
        defaultCallingCode: state => state.settings.defaultCallingCode,
        pointsConfig: state => state.settings.points,
      }),
      pointsSymbol() {
        return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
      },
      pointsName() {
        const name = this.pointsConfig.name ? this.pointsConfig.name : this.$t('Points');

        return name.charAt(0).toUpperCase() + name.slice(1);
      },
      callingCodeOptions() {
        const options = [
          {value: null, text: this.$t('Select') + '...'}
        ];
        for (const code in this.callingCodes) {
          options.push({
            value: code,
            text: this.callingCodes[code]
          });
        }
        return options;
      },
      isFormValid() {
        const quantity = Number.parseInt(this.order.quantity, 10);
        if (!this.stateOrder || !Number.isInteger(quantity)
          || quantity < 1 || quantity > this.stateOrder.order_limit) {
          return false;
        }

        if (this.showDeliveryMethodSelect && !this.order.delivery) {
          return false;
        }

        if (this.order.delivery.startsWith('pickup')) {
          return true;
        }

        return Boolean(
          this.order.name
          && this.order.surname
          && this.order.address
          && this.order.city
          && this.order.postcode
          && this.order.phone
        );
      },
      points() {
        const points = this.stateOrder ? this.stateOrder.points : 1;
        return points * this.order.quantity;
      },
      showShipmentForm() {
        return !this.showDeliveryMethodSelect || this.order.delivery.startsWith('shipment');
      },
      showDeliveryMethodSelect() {
        return !this.delivery.shipment && this.delivery.pickup
            || this.delivery.shipment && this.delivery.pickup;
      }
    },
    watch: {
      defaultCallingCode(newValue) {
        if (newValue && !this.order.phone_calling_code) {
          this.order.phone_calling_code = newValue;
        }
      },
      'order.name'() {
        this.setFieldState('name');
      },
      'order.surname'() {
        this.setFieldState('surname');
      },
      'order.address'() {
        this.setFieldState('address');
      },
      'order.city'() {
        this.setFieldState('city');
      },
      'order.postcode'() {
        this.setFieldState('postcode');
      },
      'order.phone_local'(newValue) {
        if (newValue) {
          const cleaned = newValue.replace(/\D/g, '');
          if (cleaned !== newValue) {
            this.order.phone_local = cleaned;
          }
        }
        this.setFieldState('phone');
      },
      'order.phone_calling_code'() {
        this.setFieldState('phone');
      },
      'order.details'() {
        this.setFieldState('details');
      },
      'order.quantity'(newValue) {
        if (!this.stateOrder) {
          this.state.order.quantity = null;
          return;
        }

        this.state.order.quantity = newValue > 0 && newValue <= this.stateOrder.order_limit;

        if (newValue > this.stateOrder.order_limit) {
          this.order.quantity = this.stateOrder.order_limit;
        }
      },
      'order.delivery'() {
        this.clearFormState();
      }
    }
  }
</script>

<style scoped>

</style>
